import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileSignature,
  faWalking,
  faShieldAlt,
  faGears,
  faList,
  faClipboardCheck,
} from "@fortawesome/free-solid-svg-icons";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import StatisticsCard from "../uielements/StatisticsCard";
import Api from "../../helpers/apiHandler";
import countsActions from "../../redux/counts/actions";
import { loginUserType, newPermissionValue } from "../../helpers/constants";
import { permissionModuleNameMatchesRoutePath } from "../../helpers/utility";
import { prefetchRoutes } from "../../helpers/prefetchRoutes";

const { updateCount } = countsActions;
const api = new Api();

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 20px;
  @media only screen and (max-width: 425px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;
const RegulatoryComplianceCounts = ({
  onUpdateCount,
  counts,
  companyId,
  sideBarItems,
  ...props
}) => {
  const [count, setCount] = useState({});
  const [isVisitor, setIsVisitor] = useState(false);
  const [isInspection, setIsInspection] = useState(false);
  const [isChecklist, setIsChecklist] = useState(false);
  const [isSafety, setIsSafety] = useState(false);
  const [isGlobalCertification, setIsGlobalCertification] = useState(false);
  const [isDocumentControl, setIsDocumentControl] = useState(false);

  useEffect(() => {
    if (sideBarItems && sideBarItems.length > 0) {
      sideBarItems.forEach((item) => {
        const desc = item.moduleDescription || item.description;
        if (permissionModuleNameMatchesRoutePath(item.moduleName, desc, "visitors")) {
          if (item.permissionId !== newPermissionValue.noAccess) {
            setIsVisitor(true);
          } else {
            setIsVisitor(false);
          }
        }
        if (permissionModuleNameMatchesRoutePath(item.moduleName, desc, "inspections")) {
          if (item.permissionId !== newPermissionValue.noAccess) {
            setIsInspection(true);
          } else {
            setIsInspection(false);
          }
        }
        if (permissionModuleNameMatchesRoutePath(item.moduleName, desc, "checklists")) {
          if (item.permissionId !== newPermissionValue.noAccess) {
            setIsChecklist(true);
          } else {
            setIsChecklist(false);
          }
        }
        if (permissionModuleNameMatchesRoutePath(item.moduleName, desc, "safety")) {
          if (item.permissionId !== newPermissionValue.noAccess) {
            setIsSafety(true);
          } else {
            setIsSafety(false);
          }
        }
        if (permissionModuleNameMatchesRoutePath(item.moduleName, desc, "certification")) {
          if (item.permissionId !== newPermissionValue.noAccess) {
            setIsGlobalCertification(true);
          } else {
            setIsGlobalCertification(false);
          }
        }
        if (permissionModuleNameMatchesRoutePath(item.moduleName, desc, "document-control")) {
          if (item.permissionId !== newPermissionValue.noAccess) {
            setIsDocumentControl(true);
          } else {
            setIsDocumentControl(false);
          }
        }
      });
    }
  }, [sideBarItems]);

  useEffect(() => {
    const paths = [];
    if (isVisitor) paths.push("visitors");
    if (isInspection) paths.push("inspections");
    if (isChecklist) paths.push("checklists");
    if (isSafety) paths.push("safety");
    if (isGlobalCertification) paths.push("certification");
    if (isDocumentControl) paths.push("document-control");
    prefetchRoutes(paths);
  }, [
    isVisitor,
    isInspection,
    isChecklist,
    isSafety,
    isGlobalCertification,
    isDocumentControl,
  ]);

  const getCount = useCallback(() => {
    const payload = {
      companyId: companyId,
      menuType: "REGULATORY_AND_COMPLIANCE",
    };
    api
      .post("common/count", {
        isMultipart: false,
        data: payload,
      })
      .then((response) => {
        if (response.status === 1) {
          onUpdateCount({
            regulatoryAndCompliance: {
              numberOfVisitorsLog: response.data.visitorsLog,
            },
          });
        }
      })
      .catch((error) => {
        console.log("Error", error);
      });
  }, [companyId, onUpdateCount]);

  useEffect(() => {
    if (companyId) {
      getCount();
    }
  }, [companyId, getCount]);

  useEffect(() => {
    if (counts) {
      setCount(counts);
    }
  }, [counts]);
  return (
    <GridContainer className="width-100">
      {isVisitor && (
        <StatisticsCard
          title={"Visitors Log"}
          count={count.numberOfVisitorsLog || 0}
          icon={
            <FontAwesomeIcon
              icon={faWalking}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#9D6AB0"}
          to="/visitors"
          onClick={() => props.history.push("/visitors")}
        />
      )}
      {isInspection && (
        <StatisticsCard
          title={"Inspections"}
          icon={
            <FontAwesomeIcon
              icon={faFileSignature}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#16B9CE"}
          showOnlyTitle
          to="/inspections"
          onClick={() => props.history.push("/inspections")}
        />
      )}
      {isChecklist && (
        <StatisticsCard
          title={"CheckLists"}
          icon={
            <FontAwesomeIcon
              icon={faClipboardCheck}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#5B8DEF"}
          showOnlyTitle
          to="/checklists"
          onClick={() => props.history.push("/checklists")}
        />
      )}
      {isSafety && (
        <StatisticsCard
          title={"Safety Data Sheets"}
          icon={
            <FontAwesomeIcon
              icon={faShieldAlt}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#f0aa32"}
          showOnlyTitle
          to="/safety"
          onClick={() => props.history.push("/safety")}
        />
      )}
      {isGlobalCertification && (
        <StatisticsCard
          title={"Global Certifications and Licenses"}
          icon={
            <FontAwesomeIcon
              icon={faGears}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#20CCE2"}
          showOnlyTitle
          to="/certification"
          onClick={() => props.history.push("/certification")}
        />
      )}
      {(isDocumentControl || props.authType === loginUserType.admin) && (
        <StatisticsCard
          title={"Document Control"}
          icon={
            <FontAwesomeIcon
              icon={faList}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#56C288"}
          showOnlyTitle
          to="/document-control"
          onClick={() => props.history.push("/document-control")}
        />
      )}
    </GridContainer>
  );
};

const mapStateToProps = (state) => ({
  companyId: state.Auth.company.id,
  counts: state.Counts.regulatoryAndCompliance,
  sideBarItems: state.Auth.sideBarItems,
  authType: state.Auth.type,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateCount: (data) => dispatch(updateCount(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RegulatoryComplianceCounts)
);
